import request from '@/utils/axios.js'

// 获取申请状态及三个月券的状态
export function getApplyStatus (data) {
  return request({
    url: '/carbon/mobileAPI/creditcard/queryCmbCreditCardActiveCoupon',
    method: 'post',
    data
  })
}

// 参与隧E通招行信用卡活动
export function participateInActivity (data) {
  return request({
    url: '/carbon/mobileAPI/creditcard/participateInCmbCreditCardActive',
    method: 'post',
    data
  })
}

// 领取隧E通招行信用卡优惠券
export function receiveCoupon (data) {
  return request({
    url: '/carbon/mobileAPI/creditcard/receiveCmbCreditCardActiveCoupon',
    method: 'post',
    data
  })
}

// 信用卡活动专区 轮播图--广告位
export function queryAd (data) {
  return request({
    url: '/manageApp/mobileAPI/queryAd',
    method: 'post',
    data
  })
}
